__turbopack_context__.v({
  "content": "entry-module__J0NVaW__content",
  "entry": "entry-module__J0NVaW__entry",
  "flowLead": "entry-module__J0NVaW__flowLead",
  "flowSign": "entry-module__J0NVaW__flowSign",
  "head": "entry-module__J0NVaW__head",
  "itemLink": "entry-module__J0NVaW__itemLink",
  "label": "entry-module__J0NVaW__label",
  "lead": "entry-module__J0NVaW__lead",
  "quote": "entry-module__J0NVaW__quote",
  "srOnly": "entry-module__J0NVaW__srOnly",
  "time": "entry-module__J0NVaW__time",
  "timeText": "entry-module__J0NVaW__timeText",
  "verb": "entry-module__J0NVaW__verb",
  "words": "entry-module__J0NVaW__words",
});
